import { Step } from "react-joyride";

const addProductDrawerTourSteps: Step[] = [
  {
    target: ".tour-select-product",
    content: "Select a product you want to add to the proposal.",
  },
  {
    target: ".tour-add-product-to-proposal",
    content: "Click to add chosen product(s) and continue.",
  },
];

export default addProductDrawerTourSteps;
